export default __webpack_public_path__ + "static/media/default_avatar.45ee13d0.svg";